import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
    Grid,
    useFormContext,
    Filter,
    ActionButton,
} from "@programari-limit/base-react";
import GridFormField from "components/GridFormField";
import MuiGrid from "@mui/material/Grid";
import { columnesUsuaris } from "sharedAdvancedSearch/advancedSearchColumns";
import GridFilterField from "components/GridFilterField";
import { Box, Icon, IconButton, Tooltip } from "@mui/material";
import { SpringFilterQueryBuilder } from "utils/spring-filter-query-builder";
import { likeAny } from "utils/springFilterUtils";
import { IconButtonButtonComponent } from "components/ActionReportButtonComponents";

const ActionCrearTalonariContent = () => {
    const { data } = useFormContext();
    return (
        <MuiGrid container spacing={2} sx={{ mt: 1 }}>
            <GridFormField name="data" lg={6} />
            <GridFormField name="tipus" lg={6} />
            <GridFormField name="primerNumero" lg={4} />
            <GridFormField name="darrerNumero" lg={4} />
            <GridFormField name="numeroBonos" lg={4} />
            {/* Depenent del tipus hauria d'ensenyar els camps d'afiliat o be el de venedor */}
            {data?.tipus === "AFILIAT" && (
                <GridFormField name="afiliatNom" lg={12} />
            )}
            {data?.tipus === "VENEDOR" && (
                <GridFormField
                    name="venedor"
                    lg={12}
                    advancedSearchColumns={columnesUsuaris}
                />
            )}
            <GridFormField name="observacions" lg={12} />
        </MuiGrid>
    );
};

// Filtres de la taula
const FilterContent = (props) => {
    const { filterApiRef } = props;
    const { t } = useTranslation();

    return (
        <MuiGrid container spacing={2}>
            <GridFilterField
                name="dataInici"
                sm={6}
                md={4}
                lg={2.75}
                xl={2.25}
            />
            <GridFilterField name="dataFi" sm={6} md={4} lg={2.75} xl={2.25} />
            <GridFilterField name="numeroBono" sm={6} md={4} lg={3} xl={2} />
            <GridFilterField name="tipus" sm={6} md={4} lg={3} xl={2} />
            <GridFilterField name="afiliatNom" sm={5} md={8} lg={3.5} xl={3} />
            <GridFilterField
                name="venedor"
                sm={6}
                md={6}
                lg={4.5}
                xl={3}
                advancedSearchColumns={columnesUsuaris}
            />
            <MuiGrid item lg={0.5}>
                <Tooltip title={t("comu.resetFiltre")}>
                    <IconButton
                        onClick={() => filterApiRef?.current?.doReset()}
                    >
                        <Icon>filter_alt_off</Icon>
                    </IconButton>
                </Tooltip>
            </MuiGrid>
        </MuiGrid>
    );
};

const springFilterBuilder = (data) => {
    const { and, equal, ge, le, exists, like } = SpringFilterQueryBuilder;

    const filter = and(
        ge("data", data?.dataInici ? data?.dataInici : undefined),
        le("data", data?.dataFi ? data?.dataFi : undefined),
        equal("venedor.id", data?.venedor?.id),
        equal("tipus", data?.tipus),
        like("afiliatNom", likeAny(data?.afiliatNom)),
        data?.numeroBono &&
            exists(equal("talonariBonos.numero", data?.numeroBono))
    ).toString();

    return filter;
};

const TalonariFilter = (props) => {
    const { onSpringFilterChange, onFilterInitialized } = props;
    const filterApiRef = React.useRef();

    return (
        <Box sx={{ mb: 2 }}>
            <Filter
                name={"T_FILTER"}
                resourceName={"talonari"}
                persistentState
                springFilterBuilder={springFilterBuilder}
                onSpringFilterChange={onSpringFilterChange}
                onFilterInitialized={onFilterInitialized}
                size="small"
                apiRef={filterApiRef}
                initialOnChangeRequest
            >
                <FilterContent filterApiRef={filterApiRef} />
            </Filter>
        </Box>
    );
};

const Talonaris = () => {
    const { t } = useTranslation();
    const [fixedFilter, setFixedFilter] = React.useState();
    const [filterInitialized, setFilterInitialized] = React.useState(false);
    const gridApiRef = React.useRef();
    const navigate = useNavigate();

    const columns = [
        {
            name: "data",
            flex: 0.5,
        },
        {
            name: "primerNumero",
            flex: 0.75,
        },
        {
            name: "darrerNumero",
            flex: 0.75,
        },
        {
            name: "tipus",
            flex: 0.5,
        },
        {
            name: "afiliatNom",
            flex: 1,
        },
        {
            name: "venedor",
            flex: 1,
        },
        {
            name: "observacions",
            flex: 1,
        },
    ];

    return (
        <Grid
            apiRef={gridApiRef}
            title={t("talonaris.title")}
            resourceName="talonari"
            columns={columns}
            fixedFilter={fixedFilter}
            findDisabled={!filterInitialized}
            formRoutePath="form"
            toolbarHideCreateAction
            // rowHideEditViewAction
            rowHideDeleteAction
            // rowAdditionalActions={[
            //     {
            //         icon: "search",
            //         label: t("comu.detall"),
            //         onClick: (params) => navigate(`form/${params?.id}`),
            //         showInMenu: false,
            //     },
            // ]}
            toolbarAdditionalActions={[
                {
                    position: 2,
                    component: (
                        <ActionButton
                            resourceName="talonari"
                            code="T_CREAR"
                            detached
                            variant="contained"
                            buttonComponent={IconButtonButtonComponent}
                            icon="add"
                            formChildren={<ActionCrearTalonariContent />}
                            formInitialOnChangeRequest
                            onSuccess={() => {
                                gridApiRef?.current?.doRefresh();
                            }}
                        />
                    ),
                },
            ]}
            toolbarAdditionalRow={
                <TalonariFilter
                    onSpringFilterChange={setFixedFilter}
                    onFilterInitialized={() => setFilterInitialized(true)}
                />
            }
            density="compact"
            defaultSortModel={[
                {
                    field: "primerNumero",
                    sort: "desc",
                },
            ]}
        />
    );
};

export default Talonaris;
